module.exports = __webpack_public_path__ + "static/media/tick_icon_active.bbf5579f.svg";